// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Conclusion_buttons__8BGEv","center":"Conclusion_center__1IAWu","green":"Conclusion_green__lcKTE"};